import {TRANSLATION, Yup, useTranslation } from "@/imports-files/common/common"; // Assuming t is correctly imported

export const SHARE_CV = {
  share_with: '',
  title_note: ''
};

export const getShareCvValidationSchema = (t) => Yup.object({
  share_with: Yup.string().email(t('errors:invalid_email')),
  title_note: Yup.string().required(t('errors:required'))
});
